import { AppState } from 'src/app/store'
import { CompanySliceState } from 'src/core/models'

const companyState: CompanySliceState = {
  companyDetails: {
    loading: false,
    data: null
  },
  editCompany: {
    loading: false,
    success: false,
    error: null
  }
}

export const companyDetailsSelector = (state: AppState) => state.companies.companyDetails
export const editCompanySelector = (state: AppState) => state.companies.editCompany

export { companyState as initialState }
